import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import {
  BiPalette,
  kBiPaletteNames,
  kBiVizStyleOptionNames,
} from '@euler/model/bi/viz';
import { memo } from 'react';
import { View } from 'react-native';
import { BiChip } from '../../../../components/ui/BiChip';
import { BiPaletteSwatch } from '../../../../components/ui/BiPaletteSwatch';
import { StyleGroup } from '../StyleGroup';
import { biWithStyleOption } from '../functions/biStyleEdit';
import { BiStyleOptionProps } from '../functions/biStyleOptionProps';

const kPalettes = Object.values(BiPalette);

/** The card's own palette, or the dashboard's. */
export const PaletteOptions = memo(
  ({
    style,
    dashboardPalette,
    onChange,
  }: BiStyleOptionProps & { dashboardPalette: BiPalette | undefined }) => {
    const { rpx } = useResponsiveContext();
    const pick = (palette: BiPalette | undefined) =>
      onChange(biWithStyleOption(style, 'palette', palette));
    return (
      <StyleGroup title={kBiVizStyleOptionNames.palette}>
        <View style={{ flexDirection: 'row', flexWrap: 'wrap', gap: rpx(6) }}>
          <BiChip
            label={
              dashboardPalette
                ? `跟随看板（${kBiPaletteNames[dashboardPalette]}）`
                : '默认'
            }
            selected={!style?.palette}
            onPress={() => pick(undefined)}
          />
          {kPalettes.map(palette => (
            <BiChip
              key={palette}
              label={kBiPaletteNames[palette]}
              selected={style?.palette === palette}
              onPress={() => pick(palette)}
            />
          ))}
        </View>
        <BiPaletteSwatch
          palette={style?.palette ?? dashboardPalette ?? BiPalette.Default}
        />
      </StyleGroup>
    );
  },
);
